import { useI18n } from "../context/I18nContext";
import { Globe, Loader2 } from "lucide-react";

export default function LanguageSwitcher() {
  const { lang, setLang, isStatic, autoLoading } = useI18n();
  return (
    <div className="flex items-center gap-1.5" data-testid="language-switcher">
      {!isStatic && (
        <span className="hidden sm:flex items-center gap-1 text-[11px] font-semibold text-muted-foreground bg-muted rounded-full px-2 py-1" title="Auto-translated for your region">
          {autoLoading ? <Loader2 className="w-3 h-3 animate-spin" /> : <Globe className="w-3 h-3" />}
          {lang.toUpperCase()} · auto
        </span>
      )}
      <div className="flex items-center rounded-full bg-muted p-0.5">
        {["en", "es"].map((l) => (
          <button
            key={l}
            onClick={() => setLang(l)}
            data-testid={`lang-${l}`}
            className={`px-2.5 py-1 rounded-full text-xs font-bold transition-colors ${lang === l ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}
          >
            {l.toUpperCase()}
          </button>
        ))}
      </div>
    </div>
  );
}
